"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
console.debug('INFO CountryCodeValidationPlugin.ts loaded');
var CountryCodeValidationPlugin = /** @class */ (function (_super) {
    __extends(CountryCodeValidationPlugin, _super);
    function CountryCodeValidationPlugin(field, telephoneNumberField) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        _this.telephoneNumberField = telephoneNumberField;
        return _this;
    }
    CountryCodeValidationPlugin.prototype.isValid = function () {
        return this._isCountryCodeValid();
    };
    CountryCodeValidationPlugin.prototype.runCustomValidation = function () {
        this._isCountryCodeValid();
    };
    CountryCodeValidationPlugin.prototype._isCountryCodeValid = function () {
        if (this.field.value === '' && this.telephoneNumberField.value !== '') {
            this.field.setCustomValidity('Please select a country code');
            return false;
        }
        else if (this.field.value !== '' && this.telephoneNumberField.value !== '') {
            this.field.setCustomValidity('');
            return true;
        }
        this.field.setCustomValidity('');
        return true;
    };
    CountryCodeValidationPlugin.prototype._getMessageAttribute = function () {
        return 'data-required-error-message';
    };
    CountryCodeValidationPlugin.prototype._getDefaultMessage = function () {
        return 'This field is required and needs to be filled.';
    };
    return CountryCodeValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = CountryCodeValidationPlugin;
